module.exports = {




    /*------------------------------------*\
        checklist
        all of these items needs to be true
        before making final order
    \*------------------------------------*/
    checklist: {
        checkoutNotPerformedYet: true,
        measurementProfileValid: false,
        homeAddressValidated: false,
        deliveryMethodSelected: false,
        itemsInCart: false,
        squareCardValid: false,
        noCalculateErrors: true,
    },






    /*------------------------------------*\
        check if product needs
        measurements
    \*------------------------------------*/

    productsNeedMeasurements: function(){

        // product type ids with measurements:
        // [11, 12, 13, 14, 16, 17, 18, 20]

        var measurementsRequired = false;

        var lsCartAllItems = lsCart.getAllItems();
        for ( var key in lsCartAllItems ){
            var cartItem = lsCartAllItems[key];

            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 19].forEach(function(productTypeWithMeasurements, i){
                if (productTypeWithMeasurements==parseInt(cartItem.product_type_id)) {
                    measurementsRequired = true;
                }
            });

        }

        console.dir({
            'globalCustomerHasMeasurementProfiles': globalCustomerHasMeasurementProfiles,
            'measurementsRequired': measurementsRequired,
            'lsCartAllItems': lsCartAllItems,
        });


        //var cookie = measurementsRequired ? 1 : 0;
        //Cookies.set('CART_PRODUCTS_REQUIRE_MEASUREMENT_PROFILES', cookie, {expires: 1});

        return measurementsRequired;

    },






    showSomeErrors: function(){

        //console.dir(this.checklist);

        if (!this.checklist.measurementProfileValid) {
            alertify.alert('Some items in your cart require your measurements. Please select measurement profile and try again.');
            $('html,body').animate({scrollTop: $('.checkout__measurement-profile-input').offset().top - 70}, 500);
        }

        //else if (!this.checklist.homeAddressValidated) {
        //    alertify.alert('Please provide valid shipping address and try again.');
        //}

        else if (!this.checklist.deliveryMethodSelected) {
            alertify.alert('Please choose delivery method and try again.');
        }

        else if (!this.checklist.itemsInCart) {
            alertify.alert('Please add at least 1 item to your cart before ordering and try again.');
        }

        else if (!this.checklist.squareCardValid) {
            alertify.alert('Please add credit card before checkout.');
            // scroll to credit card form
            $('html, body').animate({ scrollTop: $('.checkout-step-square-payment').offset().top, }, 500, 'swing');
        }

    },


    checklistCheckItems: function(){

        // checklist...
        var checklist = this.checklist;

        // noCalculateErrors is being set on the checkout call...
        // checkoutNotPerformedYet also in checkout call...
        // ...


        // check items in cart...
        var allCartItems = window.lsCart.getAllItems();
        if (Object.keys(allCartItems).length>=1) {
            checklist.itemsInCart = true;
        } else {
            checklist.itemsInCart = false;
        }

        // check selected measurement profile...
        var measurementCookie = Cookies.get('CHECKOUT_SELECTED_MEASUREMENT_PROFILE');
        //if (!!measurementCookie) {
        // we need to make sure customers select a profile before ordering
        if (!!$('.js-checkout-measurement-profile.selectized').val()) {
            checklist.measurementProfileValid = true;
        } else {
            checklist.measurementProfileValid = false;
        }
        if (!this.productsNeedMeasurements()) {
            checklist.measurementProfileValid = true;
        }

        // check delivery method
        if (!!Cookies.get('CHECKOUT_SHIPPING_METHOD')) {
            checklist.deliveryMethodSelected = true;
        } else {
            checklist.deliveryMethodSelected = false;
        }

        // calculate errors...
        if (!!window.calculateError) {
            checklist.noCalculateErrors = false;
        } else {
            checklist.noCalculateErrors = true;
        }

        // check home address...
        var shippingAddressAlreadyExists = window.globalCustomerHomeAddresId;
        var shippingAddressErrorsFromCheckout = window.homeAddressErrorsFromCheckout;
        if ($('.js-home-address-form').length && window.checkoutAttemptedByClicking) {
            var shippingAddressFrontendValidated = $('.js-home-address-form').parsley({
                errorsContainer: function(ParsleyField) {
                    var selectWrapper = ParsleyField.$element.closest('.parsley-select-wrapper');
                    if (selectWrapper.length > 0) {
                        return $(selectWrapper).find('.parsley-select-errors');
                    }
                    return ParsleyField;
                },
            }).validate();
        } else {
            var shippingAddressFrontendValidated = false;
        }


        if ((shippingAddressAlreadyExists || shippingAddressFrontendValidated) && (!shippingAddressErrorsFromCheckout)) {
            checklist.homeAddressValidated = true;
        } else {
            checklist.homeAddressValidated = false;
        }



        if (window.globalCustomerHasSquareCard) {
            checklist.squareCardValid = true;
        } else {
            checklist.squareCardValid = false;
        }



        // log status...
        console.debug('Checkout Checklist Status: ', checklist);

    },




    /*------------------------------------*\
        checklist completed
    \*------------------------------------*/
    checklistCompleted: function(){
        for(var item in this.checklist) {
            if(!this.checklist[item]) {
                //alertify.alert('Can\'t checkout yet. Not all checkout information were provided.');
                return false;
            };
        } return true;
    },


    /*------------------------------------*\
        order button handler
        enables/disabled button
    \*------------------------------------*/
    orderButtonHandler: function(){
        var btn = $('[js-checkout-page-checkout-btn]');
        //var incomplete = $('[js-checkout-incomplete]');


        if (this.checklist.noCalculateErrors) {
            $(btn).text('Complete Your Order');
        } else {
            $(btn).text('Try Again');
        }

        //if (this.checklistCompleted()) {
        //    incomplete.hide();
        //    $(btn).removeClass('is-disabled');
        //    $(btn).prop('disabled', false);
        //} else {
        //    incomplete.show();
        //    $(btn).addClass('is-disabled');
        //    $(btn).prop('disabled', true);
        //}
    },



    /*------------------------------------*\
        Shipping Address Retry
    \*------------------------------------*/
    //shippingAddressButtonHandler: function(){
    //    if (this.checklist.homeAddressValidated) {
    //        $('[js-checkout-shipping-address-btn]').hide();
    //    }
    //},



    /*------------------------------------*\
        ultimate showdown
    \*------------------------------------*/
    checkChecklistAndButton: function(){
        this.checklistCheckItems();
        this.orderButtonHandler();
        //this.shippingAddressButtonHandler();
    },








    /*------------------------------------*\
        Calculate
    \*------------------------------------*/
    calculate: function(caller){
        console.info('CHECKOUT PAGE', 'calculate() was called by: ' + caller)

        var checkout = this;
        checkout.afterAnyActionThatTriggersCalculate();

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

        checkout.calculateAndRenderPrices();

        checkout.checkChecklistAndButton();
    },




    /*--------------------------------------------------------*\
        Calculate Prices
    \*--------------------------------------------------------*/

    calculateAndRenderPrices: function(options){
        options = options ? options : {};

        var checkout = this;
        var pageEl = $('[js-checkout-page-container]');

        var btn = $('[js-checkout-page-checkout-btn]');

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();


        // no longer adding products to cart every time we calculate prices - only done when checkout page is opened
        // checkout.addLocalProductsToBackendCart
        //function(){


        // INITIAL REQUEST DATA

        var requestData = {
            'special_instructions': '',
            'shipping_method': Cookies.get('CHECKOUT_SHIPPING_METHOD') ? Cookies.get('CHECKOUT_SHIPPING_METHOD') : 'SHIP1',
            'calculate': 'true',
            'ephCountry': ephGlobals.country,
        };



        // REFERRAL CODE

        // check if it already has referral code referred value
        if ( pageEl.find('[js-rsrefcode-isreferred-value]').val() ) {
            // and do nothing
        }

        // if not check if user manually entered referral code
        else if ( pageEl.find('input[name="rsrefcode"]').val() ) {
            requestData.rsrefcode = pageEl.find('input[name="rsrefcode"]').val();
        }

        // if not then check if it's in cookies
        else if (Cookies.get('CHECKOUT_RSREFCODE')) {
            requestData.rsrefcode = Cookies.get('CHECKOUT_RSREFCODE');
        }



        // PROMO CODE

        if (Cookies.get('CHECKOUT_PROMO_CODE')) {
            requestData.promo_code = ( Cookies.get('CHECKOUT_PROMO_CODE') ).toUpperCase();
        }


        // ADDRESS
        var AddressLine1 = pageEl.find('input[name="AddressLine1"]').val();
        var AddressLine2 = '';
        var City = pageEl.find('input[name="City"]').val();
        var Country = pageEl.find('select[name="Country"]').val();
        var State = pageEl.find('select[name="State"]').val();
        var ZipCode = pageEl.find('input[name="ZipCode"]').val();

        AddressLine1 ? (requestData.AddressLine1 = AddressLine1) : null;
        AddressLine2 ? (requestData.AddressLine2 = AddressLine2) : null;
        City ? (requestData.City = City) : null;
        Country ? (requestData.Country = Country) : null;
        State ? (requestData.State = State) : null;
        ZipCode ? (requestData.ZipCode = ZipCode) : null;



        // MEASUREMENT PROFILE
        var measurementProfile = $('.js-checkout-measurement-profile.selectized').val();



        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();


        // SUCCESS

        var success = function(data){
            window.calculateError = false;
            options.success ? options.success.call(this, data) : false;
        };


        // ERROR

        var error = function(jqXHR, textStatus, errorThrown){
            $('[js-checkout-loader]').hide();
            $('[js-checkout-prices]').hide();
            window.calculateError = (jqXHR.responseJSON && jqXHR.responseJSON.error) ? jqXHR.responseJSON.error : true;
            options.error ? options.error.call(this, jqXHR, textStatus, errorThrown) : false;
        };



        // COMPLETE

        var complete = function(jqXHR, textStatus){


            //
            if (jqXHR.responseJSON) {
                var data = jqXHR.responseJSON;


                //........
                window.homeAddressErrorsFromCheckout = false;

                if (data.msg.toLowerCase() == 'validation error') {
                    if (data.City || data.AddressLine1 || data.State || data.ZipCode) {
                        window.homeAddressErrorsFromCheckout = true;
                    }
                }


                // check checkout checklist and enable/disable 'complete order' button
                checkout.checkChecklistAndButton();

            }

            //
            else {
                window.calculateError = true;
                alertify.alert('Something went wrong...');

                // check checkout checklist and enable/disable 'complete order' button
                checkout.checkChecklistAndButton();

                return false;
            }




            // discount code invalid...
            if ((data.error == 'true') && (data.msg.toLowerCase() == 'invalid promo code')) {
                Cookies.remove('CHECKOUT_PROMO_CODE');
                $('[js-promo-code-input]').val('');
                $('[js-promo-code-btn]').text('ADD');
                alertify.alert('Invalid discount code.');
                checkout.calculate('invalid discount code 2');


                // check checkout checklist and enable/disable 'complete order' button
                checkout.checkChecklistAndButton();

                return false;
            }

            // measurement required
            if (data.msg.toLowerCase() == 'measurement profile selection is required') {

                alertify
                .okBtn('Get Fitted')
                .alert(
                        'To ensure that you\'ll get perfect fit on your order we need to have your measurements before making the order.',
                    function () {
                        window.location.href = WP_SITEURL + '/checkout-fitting/';
                    }
                );
                alertify.reset();

                window.calculateError = true;


                // check checkout checklist and enable/disable 'complete order' button
                checkout.checkChecklistAndButton();


                return false;

            }




            if (data.error == 'true') {
                window.calculateError = (jqXHR.responseJSON && jqXHR.responseJSON.error) ? jqXHR.responseJSON.error : true;

                if (data.msg.toLowerCase() == 'validation error') {
                    var errors = '';
                    for(var key in data.data){
                        errors += data.data[key];
                    }
                    alertify.alert(String(errors).capitalize());
                }

                else {
                    alertify.alert(String(data.msg).capitalize());
                }


                // check checkout checklist and enable/disable 'complete order' button
                checkout.checkChecklistAndButton();

                return false;
            }


            checkout.afterCalculateCall(data);

            // check checkout checklist and enable/disable 'complete order' button
            checkout.checkChecklistAndButton();

        };



        // PASS IT ALL

        checkout.checkoutOrder(requestData, measurementProfile, success, error, complete );


        //}

    },





    /*--------------------------------------------------------*\
        after any action that triggers calculate
    \*--------------------------------------------------------*/

    afterAnyActionThatTriggersCalculate: function(){
        var checkout = this;

        $('[js-checkout-prices]').addClass('is-loading');

        $('[js-checkout-loader]').show();
        $('[js-checkout-prices]').hide();

        //$('[js-checkout-page-checkout-btn]').prop('disabled', true);
        //$('[js-checkout-page-checkout-btn]').addClass('is-disabled');

        $('[js-rsrefcode-btn]').prop('disabled', true);
        $('[js-rsrefcode-btn]').addClass('is-disabled');

        $('[js-promo-code-btn]').prop('disabled', true);
        $('[js-promo-code-btn]').addClass('is-disabled');

        $('[js-rsrefcode-input]').prop('disabled', true);
        $('[js-rsrefcode-input]').addClass('is-disabled');

        $('[js-promo-code-input]').prop('disabled', true);
        $('[js-promo-code-input]').addClass('is-disabled');

        $('.js-cart-item-remove').prop('disabled', true);
        $('.js-cart-item-remove').addClass('is-disabled');

        $('input[type="radio"][name="shipping_method"]').prop('disabled', true);
        $('input[type="radio"][name="shipping_method"]').addClass('is-disabled');

        $('[js-cart-hst-wrapper]').hide();
        $('[js-cart-gst-wrapper]').hide();
        $('[js-cart-pst-wrapper]').hide();
        $('[js-cart-shipping-wrapper]').hide();
        $('[js-cart-customizations-wrapper]').hide();
        $('[js-cart-rsref-discount-wrapper]').hide();
        $('[js-cart-total-discount-wrapper]').hide();

        $('[js-cart-subtotal]').text(' loading...');
        $('[js-cart-subtotal-before-taxes]').text(' loading...');
        $('[js-cart-total]').text(' loading...');
        $('[js-cart-hst]').text(' loading...');
        $('[js-cart-gst]').text(' loading...');
        $('[js-cart-pst]').text(' loading...');
        $('[js-cart-shipping]').text(' loading...');
        $('[js-cart-customizations]').text(' loading...');
        $('[js-cart-rsref-discount]').text(' loading...');
        $('[js-cart-total-discount]').text(' loading...');

        $('[js-small-text-notification-before-checkout-btn]').removeClass('is-visible');
        $('[js-small-text-notification-before-checkout-btn]').text('');

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

    },




    /*--------------------------------------------------------*\
        after calculate call
    \*--------------------------------------------------------*/

    afterCalculateCall: function(data){
        var checkout = this;

        $('[js-checkout-prices]').removeClass('is-loading');

        $('[js-checkout-loader]').hide();
        $('[js-checkout-prices]').show();

        //$('[js-checkout-page-checkout-btn]').prop('disabled', false);
        //$('[js-checkout-page-checkout-btn]').removeClass('is-disabled');

        $('[js-rsrefcode-btn]').prop('disabled', false);
        $('[js-rsrefcode-btn]').removeClass('is-disabled');

        $('[js-promo-code-btn]').prop('disabled', false);
        $('[js-promo-code-btn]').removeClass('is-disabled');

        $('[js-rsrefcode-input]').prop('disabled', false);
        $('[js-rsrefcode-input]').removeClass('is-disabled');

        $('[js-promo-code-input]').prop('disabled', false);
        $('[js-promo-code-input]').removeClass('is-disabled');

        $('.js-cart-item-remove').prop('disabled', false);
        $('.js-cart-item-remove').removeClass('is-disabled');

        $('input[type="radio"][name="shipping_method"]').prop('disabled', false);
        $('input[type="radio"][name="shipping_method"]').removeClass('is-disabled');

        /*
        if (data.data.ReferralCode) {
            $('[js-cart-refferal-code-in-totals]').text( data.data.ReferralCode );
        }
        */

        if (data.data.OrderSubTotal) {
            $('[js-cart-subtotal]').text( parseFloat( data.data.OrderSubTotal ).toFixed(2) );
        }


        if (data.data.DiscountedOrderTotal) {
            $('[js-cart-subtotal-before-taxes]').text( parseFloat( data.data.DiscountedOrderTotal ).toFixed(2) );
        }

        if ((data.data.BalanceDue === 0)  || data.data.BalanceDue > 0) {
            $('[js-cart-total]').text( parseFloat( data.data.BalanceDue ).toFixed(2) );

            if (!!window._gaflag_cart_total || window._gaflag_cart_total != $('[js-cart-total]').text()) {
                window._gaflag_cart_total = $('[js-cart-total]').text()
                window.ga('send', {
                    hitType: 'event',
                    eventCategory: 'cart',
                    eventAction: 'order total calculated - ' + $('[js-cart-total]').text(),
                });

                window.fbq('track', "InitiateCheckout", {
                    value: data.data.BalanceDue,
                    currency: "CAD",
                    contents: Object.keys(lsCart.getAllItems()).map(function(key) {return lsCart.getAllItems()[key];}),
                    num_items: Object.keys(lsCart.getAllItems()).length
                })
            }

        }

        if (parseInt(data.data.HSTTotal) ) {
            $('[js-cart-hst-wrapper]').show();
            $('[js-cart-hst]').text( parseFloat( data.data.HSTTotal ).toFixed(2) );
        } else {
            $('[js-cart-hst-wrapper]').hide();
        }

        if (parseInt(data.data.GSTTotal) ) {
            $('[js-cart-gst-wrapper]').show();
            $('[js-cart-gst]').text( parseFloat( data.data.GSTTotal ).toFixed(2) );
        } else {
            $('[js-cart-gst-wrapper]').hide();
        }

        if (parseInt(data.data.PSTTotal) ) {
            $('[js-cart-pst-wrapper]').show();
            $('[js-cart-pst]').text( parseFloat( data.data.PSTTotal ).toFixed(2) );
        } else {
            $('[js-cart-pst-wrapper]').hide();
        }

        if (parseInt(data.data.CustomizationOptionsCost) ) {
            $('[js-cart-customizations-wrapper]').show();
            $('[js-cart-customizations]').text( parseFloat( data.data.CustomizationOptionsCost ).toFixed(2) );
        } else {
            $('[js-cart-customizations-wrapper]').hide();
        }

        if (parseInt(data.data.ShippingCost) ) {
            $('[js-cart-shipping-wrapper]').show();
            $('[js-cart-shipping]').text( parseFloat( data.data.ShippingCost ).toFixed(2) );
        } else {
            $('[js-cart-shipping-wrapper]').hide();
        }

        if (parseInt(data.data.GSTTotal) ) {
            $('[js-cart-gst-wrapper]').show();
            $('[js-cart-gst]').text( parseFloat( data.data.GSTTotal ).toFixed(2) );
        } else {
            $('[js-cart-gst-wrapper]').hide();
        }


        if (parseInt(data.data.TotalDiscountAmount)) {
            $('[js-cart-total-discount-wrapper]').show();
            $('[js-cart-total-discount]').text( parseFloat( data.data.TotalDiscountAmount ).toFixed(2) );
        }




        if ( (parseInt(data.data.TotalDiscountAmount) === 0)  && $('[js-promo-code-input]').val() ) {
            alertify.alert('Provided discount code doesn\'t apply to any of the products in the cart. You can still checkout with the original prices.');
        }


        // api values
        var NoReferralRewardReasons = (
            data.data.NoReferralRewardReasons ? data.data.NoReferralRewardReasons : false
        );

        var SmallTextNotifHTML = (NoReferralRewardReasons && NoReferralRewardReasons.length) ? NoReferralRewardReasons.map(function(reason, index) {

            if (reason == 'order-less-65') {
                return ['<div>You have active referral discount on your account but this order total is too low for it to be applied. The order must be at least $65 (before taxes and shipping).</div>'];
            }
            if (reason == 'valid-promo') {
                return ['<div>Discount code is valid but doesn\'t apply to items in cart.</div>'];
            }
            if (reason == 'gift-card-present') {
                return ['<div>You have active referral discount on your account but it was disabled because some of the items (e.g. gift cards) in your cart can\'t be used with it.</div>'];
            }

            return [];

        }) : [];

        if (!data.data.RedeemedBefore && data.data.ReferralRewardDiscount) {
            SmallTextNotifHTML.push('<div>Referral discount was applied to this order.</div>');
        }

        if (parseInt(data.data.TotalDiscountAmount) === 0 && data.data.PromoCode !== '') {
            SmallTextNotifHTML.push('<div>The discount code submitted does not apply to the items in your cart.</div>');
        }

        if (SmallTextNotifHTML && SmallTextNotifHTML.length) {
            $('[js-small-text-notification-before-checkout-btn]').addClass('is-visible');
            $('[js-small-text-notification-before-checkout-btn]').html(SmallTextNotifHTML.join(' '));
        }


        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

    },




    /*------------------------------------*\
        checkout order
    \*------------------------------------*/

    checkoutOrder: function(requestData, measurementId, success, error, complete){
        var checkout = this;


        var withmeas = '/with-measurement/' + (measurementId ? measurementId : '0');
        var shipto = '/ship-to/' + (globalCustomerHomeAddresId ? globalCustomerHomeAddresId : '0');

        // always set shipping address to zero to use the customer supplied one during checkout
        shipto = '/ship-to/0';

        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/checkout' + withmeas + shipto;

        $.ajax({
            url: action,
            type: 'POST',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },
            data: requestData,
            complete: function(jqXHR, textStatus){
                if (complete) {
                    complete.call(this, jqXHR, textStatus);
                }
            },
            success: function(data, textStatus, jqXHR){
                if (success) {
                    if (!!!requestData.calculate) {

                        checkout.fireConversionPixels()
                        checkout.logLocalStorage(data)

                    }
                    success.call(this, data, textStatus, jqXHR);
                }
            },
            error: function(jqXHR, textStatus, errorThrown){
                if (error) {
                    error.call(this, jqXHR, textStatus, errorThrown);
                    ((typeof window.Bugsnag) != 'undefined') && window.Bugsnag.notify("checkoutOrderError", "checkoutOrder", {
                        "requestUrl": action,
                        "requestData": requestData,
                        "response": jqXHR
                    })
                }
            },
        });

    },





    /*------------------------------------*\
        add multiple products
        to backend cart
    \*------------------------------------*/
    addLocalProductsToBackendCart: function(success, isCheckout, retrying){
        var checkout = this;
        var isCheckout = (typeof isCheckout == 'undefined') ? true : isCheckout;

        if (typeof globalCustomerId === 'undefined') {return false;}

        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/cart/add-many-items';

        var requestData = {};
        requestData.items = [];

        var lsCartItems = lsCart.getAllItems();
        for (var key in lsCartItems) {

            var customizations = lsCartItems[key].customizations ? lsCartItems[key].customizations : false;

            if (customizations && (customizations.length > 0)) {

                // delete properties not used by backend cart
                // no longer deleting properties not used by backend cart, because we need them later when retrieved
                // otherwise, we need to pull the new values from the backend
                customizations.forEach( function(option, index) {
                    // option.titleOfStep ? delete option.titleOfStep : false;
                    // option.valueTitle ? delete option.valueTitle : false;
                    option.valueId ? delete option.valueId : false;
                    option.valueText ? delete option.valueText : false;
                });

                var finalCustomizationsString = JSON.stringify( customizations );


            } else {
                var finalCustomizationsString = '[]';
            }

            var itemObject = {
                wa_web_product_id: parseInt( lsCartItems[key].id ),
                quantity: 1,
                customization_options: finalCustomizationsString,
                js_cart_object: JSON.stringify(lsCartItems[key])
            };

            requestData.items.push(itemObject);

        }

        if (isCheckout && requestData.items.length == 0) {
            console.info('EXIT flow... isCheckout and no local cart items.');
            return false;
        }

        //window.eph.checkoutItems = requestData;

        $.ajax({
            url: action,
            type: 'POST',
            //dataType: ,
            data: requestData,
            headers: {
                //'Content-Type': 'application/x-www-form-urlencoded',
                //'Accept': 'application/json',
                'Authorization': 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
            },
            complete: function(jqXHR, textStatus){

                // check checkout checklist and enable/disable 'complete order' button
                isCheckout && checkout.checkChecklistAndButton();
            },
            success: function(data, textStatus, jqXHR){
                if (success) {
                    success.apply(this, [data, textStatus, jqXHR]);
                }
            },
            error: function(jqXHR, textStatus, errorThrown){
                ((typeof window.Bugsnag) != 'undefined') && window.Bugsnag.notify("addLocalProductsToBackendCartError", "addLocalProductsToBackendCart", {
                    "requestUrl": action,
                    "requestData": requestData,
                    "response": jqXHR
                })

                setTimeout(function () {
                    if (!retrying) {
                        checkout.addLocalProductsToBackendCart(success, isCheckout, retrying);
                    }
                }, 2000);
            },
        });




        // check checkout checklist and enable/disable 'complete order' button
        isCheckout && checkout.checkChecklistAndButton();


        /*

        &items[0][wa_web_product_id]=23
        &items[0][quantity]=1
        &items[0][customization_options]={"CustomizationGroup":"Shirt+Options","CustomizationType":"Fit","CustomizationOptionId":20,"Value":{"Id":39,"OMSName":"Modern","Name":"Modern","Description":"Modern","Value":null,"Selected":true,"Images":[{"Id":34,"ImageTypeId":12,"FilePath":"/Images/Customizations","FileName":"shirt_modern.jpg","AltText":"EPH+Apparel+Customization","Width":110,"Height":110,"FileSource":"../Images/Customizations/shirt_modern.jpg","ThumbnailId":"modern"}]}}

        &items[1][wa_web_product_id]=1
        &items[1][quantity]=2
        &items[1][customization_options]={"CustomizationGroup":"Shirt+Options","CustomizationType":"Fit","CustomizationOptionId":20,"Value":{"Id":39,"OMSName":"Modern","Name":"Modern","Description":"Modern","Value":null,"Selected":true,"Images":[{"Id":34,"ImageTypeId":12,"FilePath":"/Images/Customizations","FileName":"shirt_modern.jpg","AltText":"EPH+Apparel+Customization","Width":110,"Height":110,"FileSource":"../Images/Customizations/shirt_modern.jpg","ThumbnailId":"modern"}]}}

        items = [
            {
                'wa_web_product_id': 23,
                'quantity': 1,
                'customization_options': ''
            },
            {
                'wa_web_product_id': 22,
                'quantity': 1,
                'customization_options': ''
            },
        ]

        */



    },





    /*------------------------------------*\
        clear cart items
    \*------------------------------------*/
    clearBackendCartItems: function(options){
        var checkout = this;
        if (typeof globalCustomerId === 'undefined') {return false;}
        var action = EPH_API_URL + '/wa-customers/' + globalCustomerId + '/cart/clear-items';
        $.ajax({
            url: action,
            type: 'POST',
            dataType: 'json',
            headers: {
                Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                Accept: 'application/json'
            },
            complete: function(jqXHR, textStatus){
                if (options.complete) {
                    options.complete.call(this, jqXHR, textStatus);
                }

                // check checkout checklist and enable/disable 'complete order' button
                checkout.checkChecklistAndButton();
            },
            success: function(data, textStatus, jqXHR){
                if (options.success) {
                    options.success.call(this, data, textStatus, jqXHR);
                }
            },
            error: function(jqXHR, textStatus, errorThrown){

            },
        });

    },




    /*------------------------------------*\
        logLocalStorage
    \*------------------------------------*/

    logLocalStorage: function(data){
        var settings = {
            "async": true,
            "crossDomain": true,
            "url": "https://hookcat.ch/eph",
            "method": "POST",
            "headers": {
                "accept": "application/json",
                "content-type": "application/json"
            },
            "processData": false,
            "data": JSON.stringify(
                {
                    "useragent": window.navigator.userAgent,
                    "localstorage": JSON.parse(JSON.stringify(localStorage)),
                    "orderData": data
                })
        }

        $.ajax(settings).done(function (response) {
            console.log(response);
        });

    },


    /*------------------------------------*\
        fireConversionPixels
    \*------------------------------------*/

    fireConversionPixels: function(){

        var conversionPixel = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
        "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
        "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
        "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
        "})(window,document,'script','dataLayer','GTM-KB586WK');";

        console.info('Firing GTM conversion pixel')
        this.addJS(conversionPixel)

    },



    /*------------------------------------*\
        addJS
    \*------------------------------------*/

    addJS: function(jsCode) {
        var s = document.createElement('script');

        s.type = 'text/javascript';
        s.innerText = jsCode;
        document.getElementsByTagName('head')[0].appendChild(s);
    },




    /*------------------------------------*\
        summary sticky
    \*------------------------------------*/

    stickySummary: function(){
        $('[js-checkout-sticky-summary]').stick_in_parent({
            //offset_top: 70,
        });
    },







}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/checkout-functions.js